export enum ActivityStatus {
  None = 'None',
  Pending = 'Pending',
  Running = 'Running',
  RunningUpscale = 'RunningUpscale',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  CompletedWithErrors = 'CompletedWithErrors',
  Failed = 'Failed',
}

export const PENDING_STATUSES = [
  ActivityStatus.Running,
  ActivityStatus.Pending,
  ActivityStatus.RunningUpscale,
] as const

export const activityStatusToLabelMap: Record<ActivityStatus, string> = {
  [ActivityStatus.None]: 'None',
  [ActivityStatus.Pending]: 'Pending',
  [ActivityStatus.Running]: 'Running',
  [ActivityStatus.Completed]: 'Completed',
  [ActivityStatus.CompletedWithErrors]: 'Errors',
  [ActivityStatus.Failed]: 'Failed',
  [ActivityStatus.Cancelled]: 'Cancelled',
  [ActivityStatus.RunningUpscale]: 'Upscaling',
}

export const activityStatusColorMap: Record<
  ActivityStatus,
  'informative' | 'subtle' | 'brand' | 'success' | 'warning' | 'danger' | 'severe'
> = {
  [ActivityStatus.None]: 'informative',
  [ActivityStatus.Pending]: 'subtle',
  [ActivityStatus.Running]: 'brand',
  [ActivityStatus.RunningUpscale]: 'brand',
  [ActivityStatus.Completed]: 'success',
  [ActivityStatus.CompletedWithErrors]: 'severe',
  [ActivityStatus.Failed]: 'danger',
  [ActivityStatus.Cancelled]: 'warning',
}
